import { useEffect, useState } from "react";
import { subscribe } from "../lib/hyperliquid";
import MarketStrip from "../components/terminal/MarketStrip";
import PriceChart from "../components/terminal/PriceChart";
import OrderBook from "../components/terminal/OrderBook";
import TradeTape from "../components/terminal/TradeTape";
import SwapTicket from "../components/terminal/SwapTicket";
import BubeOrderBook from "../components/terminal/BubeOrderBook";
import PositionsPanel from "../components/terminal/PositionsPanel";
import MarketSelector from "../components/terminal/MarketSelector";
import WalletMini from "../components/terminal/WalletMini";

export default function Terminal() {
    const [coin, setCoin] = useState("BTC");
    const [quote, setQuote] = useState("USD"); // "USD" or cross-coin (e.g. "HYPE")
    const [mids, setMids] = useState({});
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        const unsub = subscribe({ type: "allMids" }, (d) => setMids(d.mids || {}));
        return unsub;
    }, []);

    // Synthetic cross-pair mid for display when quote != USD.
    const baseMid = parseFloat(mids[coin]) || null;
    const quoteMid = quote === "USD" ? null : (parseFloat(mids[quote]) || null);
    const midPrice = quote === "USD" ? baseMid : (baseMid && quoteMid ? baseMid / quoteMid : null);

    return (
        <div className="bg-[#050505] bg-grid-fine min-h-[calc(100vh-3.5rem)]">
            <div className="max-w-[1880px] mx-auto p-2 lg:p-3 grid gap-2">
                {/* TOP BAR: market selector + wallet + strip */}
                <div className="flex flex-wrap items-stretch gap-2">
                    <MarketSelector coin={coin} quote={quote} onSelect={(c) => { setCoin(c); setQuote("USD"); }} />
                    <div className="flex-1 min-w-0">
                        <MarketStrip coin={coin} quote={quote} midPrice={midPrice} />
                    </div>
                    <WalletMini />
                </div>

                {/* MAIN 3-COL GRID */}
                <div className="grid grid-cols-1 xl:grid-cols-[1.7fr_0.9fr_0.95fr] gap-2">
                    <div className="grid gap-2">
                        <PriceChart coin={coin} quote={quote} />
                        <BubeOrderBook coin={coin} refreshKey={refreshKey} />
                    </div>
                    <div className="grid gap-2">
                        <OrderBook coin={coin} />
                        <TradeTape coin={coin} />
                    </div>
                    <div className="grid gap-2">
                        <SwapTicket
                            coin={coin}
                            midPrice={midPrice}
                            onPairChange={({ base, quote: q }) => { setCoin(base); setQuote(q || "USD"); }}
                            onCreated={() => setRefreshKey((k) => k + 1)}
                        />
                        <PositionsPanel refreshKey={refreshKey} />
                    </div>
                </div>
            </div>
        </div>
    );
}
